<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      title: "Settings",
      text: "Customer",
      text1: "Settings",
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/customer-settings/notification-settings");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <h4 class="mb-4">Notifications</h4>
            <div class="notification-table">
              <div class="table-responsive res-1">
                <table class="table table-1">
                  <thead class="table-thead">
                    <tr>
                      <th>General Notifications</th>
                      <th class="text-center">Push</th>
                      <th class="text-center">Email</th>
                      <th class="text-center">SMS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="notify-item">
                          <h6 class="mb-1">General Notifications Newsletter</h6>
                          <p>
                            Manage notification settings for timely newsletter updates.
                          </p>
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="notify-item">
                          <h6 class="mb-1">Daily Updates</h6>
                          <p>Set your notification preferences for daily updates.</p>
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input class="form-check-input input-1" type="checkbox" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-responsive res-1">
                <table class="table table-1">
                  <thead class="table-thead">
                    <tr>
                      <th>Booking</th>
                      <th class="text-center">Push</th>
                      <th class="text-center">Email</th>
                      <th class="text-center">SMS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="notify-item">
                          <h6 class="mb-1">Booking Request</h6>
                          <p>
                            Enable notifications to stay updated on your booking requests.
                          </p>
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input class="form-check-input input-1" type="checkbox" />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="notify-item">
                          <h6 class="mb-1">Booking Status</h6>
                          <p>Get instant notifications on your booking status.</p>
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input class="form-check-input input-1" type="checkbox" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="notify-item">
                          <h6 class="mb-1">Refund Request</h6>
                          <p>Receive updates on your refund request status instantly.</p>
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input class="form-check-input input-1" type="checkbox" />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input class="form-check-input input-1" type="checkbox" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-responsive res-1">
                <table class="table table-1">
                  <thead class="table-thead">
                    <tr>
                      <th>Subscription</th>
                      <th class="text-center">Push</th>
                      <th class="text-center">Email</th>
                      <th class="text-center">SMS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="notify-item">
                          <h6 class="mb-1">Subscription Notification</h6>
                          <p>Stay updated with notifications about your subscription.</p>
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input class="form-check-input input-1" type="checkbox" />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-responsive res-1 mb-0">
                <table class="table table-1">
                  <thead class="table-thead">
                    <tr>
                      <th>Wallet</th>
                      <th class="text-center">Push</th>
                      <th class="text-center">Email</th>
                      <th class="text-center">SMS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="notify-item">
                          <h6 class="mb-1">Wallet Notification</h6>
                          <p>
                            Get notifications for all wallet transactions and updates.
                          </p>
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input class="form-check-input input-1" type="checkbox" />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch ms-3">
                          <input
                            class="form-check-input input-1"
                            type="checkbox"
                            checked
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Cancel Appointment -->
</template>
